import axiosInstance from "../http/axios_instance"

const http = axiosInstance("/protected/admin", null, "/dashboard")

const updateHiddenValuation = (summary_id, hidden) =>
    http.put("/update_hidden_status", {
        summary_id,
        hidden
    })

export default {
    updateHiddenValuation,
}
